//=include  ../dataLayer.js
import DataLayer from '../dataLayer'
export default class DetailTracker {

    constructor(paxes, roomsAval, rooms) {
        this._paxes = paxes;
        this._roomRates = {};
        this.analytics = window.__pt.fn.analytics;
        this.events = window.__pt.fn.analytics.events;
        this.pages = window.__pt.fn.analytics.pages;
        this.config = window.__pt.settings || {};
        this.place = window.__pt.place || {};
        this.hotel = window.__pt.hotel || {};
        this.placeContainer = window.__pt.placeContainer || {};
        this.box = window.__pt.box || {};
        this.fn = window.__pt.fn || {};
        this.roomsAval = roomsAval;
        this.roomsTax = rooms;
        this.culture = window.__pt.culture || {};
        this.initData();
    }

    initData() {
        this.nights = this.countNight(this.box.checkIn, this.box.checkOut);
        this.location = this.hotel.location || {};
        this.url = `${location.origin}${location.pathname}`;
        this.rating = this.hotel.surveyAverage?.averageValue ? this.hotel.surveyAverage.averageValue * 2 : 0;
        this.checkIn = this.box.checkIn;
        this.checkOut = this.box.checkOut;
    }

    initialLayers(roomRates) {
        this._roomRates = roomRates;
        this.setViewSearchResult();
        this.detailPageViewEvent();
        this.setHotelImpressionView();
        this.sendPaymentFunnel();
    }

    setNotCoordinates(hotel) {
        const { location } = hotel;
        if(!this.isValidCoordinate(location)){
            const data = {
                Event: this.events.gtmEvent,
                EventAction: "HotelDetail",
                EventCategory : "Hotel sin coordenadas",
                EventExtra: hotel.hotelId,
                EventLabel: `hotelId:${hotel.hotelId}`,
                EventName: "incorrect-coordinates"
            };
            
            this.analytics.set(this.events.gtmEvent, data);
        }
    }

    setHotelImpressionView() {

        const base = this.productDetailBase();

        const data = {
            event: this.events.productDetail,
            eventName: this.events.productDetail,
            EECProductDetailAdults: base.EECProductDetailBaseAdults,
            EECProductDetailBrand: base.EECProductDetailBaseBrand,
            EECProductDetailCheckin: base.EECProductDetailBaseCheckin,
            EECProductDetailCheckout: base.EECProductDetailBaseCheckout,
            EECProductDetailCity: base.EECProductDetailBaseCity,
            EECProductDetailContractOwner: base.EECProductDetailBaseContractOwner,
            EECProductDetailCountry: base.EECProductDetailBaseCountry,
            EECProductDetailDestination: base.EECProductDetailBaseDestination,
            EECProductDetailId: base.EECProductDetailBaseId,
            EECProductDetailKids: base.EECProductDetailBaseKids,
            EECProductDetailName: base.EECProductDetailBaseName,
            EECProductDetailNights: base.EECProductDetailBaseNights,
            EECProductDetailQuantity: base.EECProductDetailBaseQuantity,
            EECProductDetailRating: base.EECProductDetailBaseRating,
            EECProductDetailRoomTypes: base.EECProductDetailBaseRoomTypes,
            EECProductDetailRoomTypesAvailable: base.EECProductDetailBaseRoomTypesAvailable,
            EECProductDetailRoomTypesOnRequest: base.EECProductDetailBaseRoomTypesOnRequest,
            EECProductDetailRoomTypesUAllotment: base.EECProductDetailBaseRoomTypesUAllotment,
            EECProductDetailRoomTypesUClosedDate: base.EECProductDetailBaseRoomTypesUClosedDate,
            EECProductDetailRoomTypesUClosedToArrival: base.EECProductDetailBaseRoomTypesUClosedToArrival,
            EECProductDetailRoomTypesUCutoff: base.EECProductDetailBaseRoomTypesUCutoff,
            EECProductDetailRoomTypesUMaxStay: base.EECProductDetailBaseRoomTypesUMaxStay,
            EECProductDetailRoomTypesUMinStay: base.EECProductDetailBaseRoomTypesUMinStay,
            EECProductDetailRoomTypesUPax: base.EECProductDetailBaseRoomTypesUPax,
            EECProductDetailStars: base.EECProductDetailBaseStars,
            EECProductDetailState: base.EECProductDetailBaseState,
            EECProductDetailWeek: base.EECProductDetailBaseWeek,
            EECProductDetailWeekDay: base.EECProductDetailBaseWeekDay,
            EECProductDetailZone: base.EECProductDetailBaseZone,
            EECProductDetailPrice: base.EECProductDetailBasePrice,
            EECProductDetailPlaceId: base.EECProductBasePlaceId,
            EECProductDetailAvailable: base.EECProductDetailBaseAvailable,
            RAPA: base.BaseRAPA,
            RAPD: base.BaseRAPD,
            EECImpressionProductUrl: base.EECImpressionBaseProductUrl,
            EECIDestinationUrl: base.EECIBaseDestinationUrl,
            EECImpressionImageUrl: base.EECImpressionBaseImageUrl,
            EECProductDetailNoAvailable: base.EECProductDetailBaseNoAvailable,
            EECProductDetailNoAvailableMaxCapacity: base.EECProductDetailBaseNoAvailableMaxCapacity,
            EECProductDetailNoAvailableMinCapacity: base.EECProductDetailBaseNoAvailableMinCapacity,
            EECProductDetailNoAvailableMaxStay: base.EECProductDetailBaseNoAvailableMaxStay,
            EECProductDetailNoAvailableMinStay: base.EECProductDetailBaseNoAvailableMinStay,
            EECProductDetailChannel: base.EECProductDetailBaseChannel
        }

        this.analytics.set(this.events.productDetail, data);
    }

    setAddToCart(itemSelected, items) {

        const base = this.addToCartBase(itemSelected, items);
        const data = {
            event: this.events.addToCart,
            EECAddToCartName: base.EECAddToCartBaseName,
            EEAddToCartId: base.EEAddToCartBaseId,
            EECAddToCartRating: base.EECAddToCartBaseRating,
            EECAddToCartStars: base.EECAddToCartBaseStars,
            EECAddToCartPrice: base.EECAddToCartBasePrice,
            EECAddToCartQuantity: base.EECAddToCartBaseQuantity,
            EECAddToCartAdults: base.EECAddToCartBaseAdults,
            EEAddToCartKids: base.EEAddToCartBaseKids,
            EECAddToCartCity: base.EECAddToCartBaseCity,
            EECAddToCartState: base.EECAddToCartBaseState,
            EECAddToCartCountry: base.EECAddToCartBaseCountry,
            EECAddToCartCheckin: base.EECAddToCartBaseCheckin,
            EECAddToCartCheckout: base.EECAddToCartBaseCheckout,
            EECAddToCartNights: base.EECAddToCartBaseNights,
            EECAddToCartPlaceId: base.EECAddToCartBasePlaceId,
            EECAddToCartMealPlan: base.EECAddToCartBaseMealPlan,
            EECAddToCartAvailable: base.EECAddToCartBaseAvailable,
            EECAddToCartBookNowPayLater: base.EECAddToCartBaseBookNowPayLater
        };

        this.analytics.set(this.events.addToCart, data);
    }

    productDetailBase() {
        const weekNumber = this.isoWeekNumber();
        const weekDay = this.getWeekDay(this.box.checkIn);
        const pax = this._paxes;
        const rooms = this.hotel.rooms || [];
        const roomRates = this._roomRates.rooms || [];
        const image = this.hotel.gallery && this.hotel.gallery.length ? this.hotel.gallery[0] : {};
        const firstRate = roomRates.length ? (roomRates[0].rate.length ? roomRates[0].rate[0] : {}) : {};
        const firstTax = firstRate.Taxes || {};
        const location = this.location;
        const rapd = this.isRAPD();
        const isAvailable = this._roomRates.rooms.length > 0;
        const listUri = `${this.config.site.siteUrl}/${this.culture.cultureCode}/${this.culture.pathHotelList}${this.placeContainer.uri}_d${this.placeContainer.id}`;
       
        const base = {
            EECProductDetailBaseAdults: pax.adults,
            EECProductDetailBaseBrand: "",
            EECProductDetailBaseCheckin: this.checkIn,
            EECProductDetailBaseCheckout: this.checkOut,
            EECProductDetailBaseCity: location.city,
            EECProductDetailBaseContractOwner: "",
            EECProductDetailBaseCountry: location.country,
            EECProductDetailBaseDestination: location.city,
            EECProductDetailBaseId: `${this.hotel.hotelId}`,
            EECProductDetailBaseKids: pax.children.length,
            EECProductDetailBaseName: this.hotel.name,
            EECProductDetailBaseNights: this.nights,
            EECProductDetailBaseQuantity: this.box.pax.rooms,
            EECProductDetailBaseRating: `${this.rating}`,
            EECProductDetailBaseRoomTypes: this.roomsAval.length + roomRates.length,
            EECProductDetailBaseRoomTypesAvailable: roomRates.length,
            EECProductDetailBaseRoomTypesOnRequest: 0,
            EECProductDetailBaseRoomTypesUAllotment: 0,
            EECProductDetailBaseRoomTypesUClosedDate: 0,
            EECProductDetailBaseRoomTypesUClosedToArrival: 0,
            EECProductDetailBaseRoomTypesUCutoff: 0,
            EECProductDetailBaseRoomTypesUMaxStay: 0,
            EECProductDetailBaseRoomTypesUMinStay: 0,
            EECProductDetailBaseRoomTypesUPax: 0,
            EECProductDetailBaseStars: this.hotel.stars,
            EECProductDetailBaseState: location.state,
            EECProductDetailBaseWeek: Number(weekNumber),
            EECProductDetailBaseWeekDay: weekDay,
            EECProductDetailBaseZone: "",
            EECProductDetailBasePrice:  roomRates.length >0 ? Math.min(...roomRates.map(item => item.lessRate)):0,
            EECProductBasePlaceId: this.hotel.placeId,
            EECProductDetailBaseAvailable: isAvailable,
            BaseRAPA: !this._roomRates.isBlockRAPD ? roomRates.length == 0 ? false : true : false,
            BaseRAPD: rapd,
            EECImpressionBaseProductUrl: this.url,
            EECIBaseDestinationUrl: listUri,
            EECImpressionBaseImageUrl: image.cloudUri,
            EECProductDetailBaseNoAvailable: this.getavailableGetRooms(),
            EECProductDetailBaseNoAvailableMaxCapacity: this.getMaxMinCapacity(true),
            EECProductDetailBaseNoAvailableMinCapacity: this.getMaxMinCapacity(false),
            EECProductDetailBaseNoAvailableMaxStay: this.getMaxMinStay(true),
            EECProductDetailBaseNoAvailableMinStay: this.getMaxMinStay(false),
            EECProductDetailBaseChannel: this.config.site.channelFac
        }

        return base;
    }

    addToCartBase(itemSelected, items) {
        const location = this.location;
        const quantity = this._roomRates.rooms.length;
        const isAvailable = quantity > 0;
        const mealPlanCodes = items.map(item => item.mealPlanCode);
        const concatenatedMealPlanCodes = mealPlanCodes.join(':');
        const base = {
            EECAddToCartBaseName: this.hotel.name,
            EEAddToCartBaseId: `${this.hotel.hotelId}`,
            EECAddToCartBaseRating: `${this.rating}`,
            EECAddToCartBaseStars: this.hotel.stars,
            EECAddToCartBasePrice: itemSelected.Amount,
            EECAddToCartBaseQuantity: quantity,
            EECAddToCartBaseAdults: itemSelected.Adults,
            EEAddToCartBaseKids: itemSelected.Kids,
            EECAddToCartBaseCity: location.city,
            EECAddToCartBaseState: location.state,
            EECAddToCartBaseCountry: location.country,
            EECAddToCartBaseCheckin: this.checkIn,
            EECAddToCartBaseCheckout: this.checkOut,
            EECAddToCartBaseNights: this.nights,
            EECAddToCartBasePlaceId: this.hotel.placeId,
            EECAddToCartBaseBookNowPayLater: itemSelected.isBookNowPayLater,
            EECAddToCartBaseMealPlan: concatenatedMealPlanCodes,
            EECAddToCartBaseAvailable: isAvailable
        }

        return base;
    }

    detailPageViewEvent() {
       
    }

    setViewSearchResult() {
        const data = {
            event: this.events.gtmEvent,
            eventName: this.events.viewSearchResults,
            eventCategory: this.events.hotels,
            eventAction: 'HotelDetail',
            eventLabel: `${this.place.displayText}`,
            eventExtra: this.pages[this.config.page]
        }

        this.analytics.set(this.events.gtmEvent, data);
    }

    selectedFilter(content) {

        const data = {
            event: this.events.gtmEvent,
            eventName: this.events.selectContent,
            eventCategory: this.events.hotels,
            eventAction: 'HotelDetail',
            eventLabel: `${this.events.typeHotel} :: ${content}`,
            eventExtra: this.pages[this.config.page]
        }

        this.analytics.set(this.events.trackEvent, data);
    }
    selectedReviews(content) {
        const pax = this._paxes;
        const data = {
            event: this.events.trackEvent,
            eventName: this.events.selectContent,
            content_type: this.events[content.content_type],
            element: `${content.elementText} :: ${content.calf}`,
            layer: this.events.hotels,
            page_type: this.events.typeHotel,
            field_hotel_name: this.hotel.name,
            field_hotel_id: this.hotel.hotelId,
            field_date1: this.checkIn,
            field_date2: this.checkOut,
            field_rooms:  this.box.pax.rooms,
            travelers_adults: pax.adults,
            travelers_children: pax.children.length,
            field_score_descr: content.calfDesc
        }

        this.analytics.set(this.events.trackEvent, data);
    }
    sendPaymentFunnel() {

        const pax = this._paxes;
        const payLaterFlag = this.isRAPD() ? 'RAPD' : 'RAPA';

        const data = {
            event: this.events.gtmEvent,
            eventName: this.events.paymentFunnel,
            eventAction: `HotelDetail | hotelId:${this.hotel.hotelId} | ${this.hotel.name}`,
            eventCategory: this.events.hotels,
            eventLabel: `${this.checkIn} | ${this.checkOut} | adults:${pax.adults} | kids:${pax.children.length} | ${payLaterFlag}`,
            eventExtra: '',
        }

        this.analytics.set(this.events.gtmEvent, data);
    }
    unavailableHotelImg(rooms, hotelId) {
        const data = {
            event: this.events.gtmEvent,
            eventName: 'unavailableHotelImg',
            eventAction: `HotelDetail`,
            eventCategory: this.events.hotelErrorImg,
            eventLabel: `habitaciones:${rooms}`,
            eventExtra: hotelId
        };
        this.analytics.set(this.events.gtmEvent, data);
    }
    roomDuplicate(rooms, hotelId) {
        const data = {
            event: this.events.gtmEvent,
            eventName: 'roomDuplicate',
            eventAction: `HotelDetail`,
            eventCategory: this.events.hotelErrorDuplicate,
            eventLabel: `habitaciones:${Array.from(rooms).join(',')}`,
            eventExtra: hotelId
        };
        this.analytics.set(this.events.gtmEvent, data);
    }
    unavailableHotel(availabilityVal,paxesFormat) {
        const isAvailable = this._roomRates.rooms.length > 0;

        if (isAvailable) {
            return;
        }

        const stPax = this.buildPaxLabel(paxesFormat);

        const data = {
            event: this.events.gtmEvent,
            eventName: this.events.hotelError,
            eventAction: `HotelDetail-${availabilityVal || 'None'}`,
            eventCategory: this.events.hotelError,
            eventLabel: `hotelId:${this.hotel.hotelId} | ci:${this.checkIn} | co:${this.checkOut} | ${stPax}`,
            eventExtra: 'unavailableHotel'
        };

        this.analytics.set(this.events.gtmEvent, data);
    }
    setAB(experiment) {
        const pax = this._paxes;
        const payLaterFlag = this.isRAPD() ? 'RAPD' : 'RAPA';
        const data = {
            event: this.events.gtmEvent,
            eventName: this.events.gtmEventAB,
            eventCategory: experiment.cookieValue,
            eventAction: `HotelDetail | hotelId:${this.hotel.hotelId} | ${this.hotel.name} | ${experiment.code}`,
            eventLabel: `${this.checkIn} | ${this.checkOut} | adults:${pax.adults} | kids:${pax.children.length} | ${payLaterFlag}`,
            eventExtra: ''
        };
        this.analytics.set(this.events.gtmEvent, data);
    }
    viewItemListTB(hotels) {
        const pax = this._paxes;
        const hotelLenght = hotels.length;
        const data = {
            event: `ga4.${this.events.trackEvent}`,
            eventName: 'view_item',
            eventParams: {
                currency: this.config.site.currency,
                channel: this.config.site.channelFac,
                field_destination: this.placeContainer.id,
                field_destination_name: this.placeContainer.displayText.split(',')[0],
                field_date1: this.checkIn,
                field_date2: this.checkOut,
                field_rooms: this.box.pax.rooms,
                field_total_nights: this.nights,
                travelers_adults: pax.adults,
                travelers_children: pax.children.length,
                page_type: this.pages[this.config.page],
                layer: this.events.hotels,
                timestamp: Date.now(),
                items: []
            }

        }

        for (let i = 0; i < hotelLenght; i++) {
            let hotel = hotels[i];
            hotel.taxes = this.roomsTax[i].rate.rate[i].taxes;
            const base = this.itemBase(hotel);
            data.eventParams.items.push({
                item_id: base.itemId,
                item_name: base.itemName,
                item_brand: base.itemBrand,
                item_category: 'hotel',
                item_category2: 'hotel',
                item_variant: null,
                price: base.price,
                coupon: base.coupon,
                item_list_name: this.placeContainer.displayText.split(',')[0],
            });
        }

        this.analytics.set('view_item', data);
    }

    itemBase(hotel) {
        return {
            itemId: hotel.hotelId,
            itemName: hotel.name,
            price: hotel.taxes ? hotel.taxes.totalRoomRatePerNight : 0,
            itemBrand: hotel.uri,
            itemCategory: this.config.page,
            itemList: this.place.name,
            position: hotel.position,
            coupon: hotel.taxes ? hotel.taxes.promotionType : null
        }
    }

    setUserInteraction(mode) {
        const payLaterFlag = mode ? 'Paga despues' : 'Paga ahora';

        const data = {
            event: this.events.gtmEvent,
            eventName: this.events.user_interaction,
            eventCategory: this.events.hotels,
            eventAction: this.events.click,
            eventLabel: payLaterFlag,
            eventExtra: this.pages[this.config.page]
        };

        this.analytics.set(this.events.gtmEvent, data);
    }

    beginCheckOutTB(itemSelected, items) {
        const pax = this._paxes;
        const rate = itemSelected.rate || {};

        const mealPlanCodes = items.map(item => item.mealPlanCode);
        const concatenatedMealPlanCodes = mealPlanCodes.join(':');
        const mappedItems = items.map(item => ({
            item_id: item.idRoom,
            item_name: item.name,
            item_brand: this.place.name,
            item_category: "habitaciones",
            item_category2: null,
            item_variant: null,
            price: item.totalRoomRatePerNight,
            coupon: item.promotionValue,
            item_list_name: "rooms",
            item_list_id: item.index
        }));

        const data = {
            event: `ga4.${this.events.trackEvent}`,
            eventName: "detail_to_checkout",
            eventParams: {
                currency: this.config.site.currency,
                value: itemSelected.Amount,
                field_destination: this.place.id,
                field_date1: this.checkIn,
                field_date2: this.checkOut,
                field_rooms: this.box.pax.rooms,
                field_total_nights: this.nights,
                travelers_adults: pax.adults,
                travelers_children: pax.children.length,
                arrival_id: this.place.id,
                meal_plan: concatenatedMealPlanCodes,
                purchase_type: itemSelected.isBookNowPayLater ? "pagar despues":"pagar ahora",
                content_type: this.events.button,
                page_type: this.pages[this.config.page],
                layer: this.events.hotels,
                timestamp: Date.now(),
                items: mappedItems
            }
        }

        this.analytics.set(this.events.gtmEvent, data);
    }
    setHotelNotRooms() {

        const pax = this._paxes;
        const payLaterFlag = this.isRAPD() ? 'RAPD' : 'RAPA';

        const data = {
            event: this.events.gtmEvent,
            eventName: this.events.notRooms,
            eventAction: `HotelDetail | hotelId:${this.hotel.hotelId} | ${this.hotel.name}`,
            eventCategory: this.events.hotels,
            eventLabel: `${this.checkIn} | ${this.checkOut} | adults:${pax.adults} | kids:${pax.children.length} | ${payLaterFlag}`,
            eventExtra: ''
        }

        this.analytics.set(this.events.gtmEvent, data);
    }
    selectDateSuggested(itemSelected) {
        const pax = this._paxes;
        
        const data = {
            event: `ga4.${this.events.trackEvent}`,
            eventName: this.events.selectContent,
            eventParams: {
                element: `available_dates:: <<${itemSelected.CheckIn}|${itemSelected.CheckOut}>`,
                field_date1: itemSelected.CheckIn,
                field_date2: itemSelected.CheckOut,
                field_hotel_name: this.hotel.name,
                travelers_adults: pax.adults,
                travelers_children: pax.children.length,
                field_hotel_id: this.hotel.hotelId,
                field_rooms:  this.box.pax.length,
                page_type: this.pages[this.config.page],
                layer: this.events.hotels,
                content_type: this.events.button
            }
        }

        this.analytics.set(this.events.gtmEvent, data);
    }
    //Filtros detalle de hotel y Botón Ver mas habitaciones
    setEventFamilyDetail(content) {
        const data = {
            event: this.events.gtmEvent,
            eventName: this.events.selectContent,
            eventCategory: this.events.hotels,   
            eventAction: this.events.button,  
            eventLabel: `${content}`, 
            eventExtra: this.pages[this.config.page],
        }
        this.analytics.set(this.events.gtmEvent, data);
    }

    //Helper functions

    countNight(checkIn, checkOut) {
        const diff = Math.abs(
            new Date(checkOut).getTime() - new Date(checkIn).getTime()
        );

        const nights = diff / (60 * 60 * 24 * 1000);

        return nights;
    }

    getWeekDay(checkIn) {
        const checkSplit = checkIn.split('-');
        const d = new Date(checkSplit.join('/'));
        const day = d.getDay();

        return day;
    }

    isoWeekNumber(date = new Date()) {
        const newDate = new Date(date);
        const dayNum = date.getUTCDay() || 7;

        newDate.setUTCDate(newDate.getUTCDate() + 4 - dayNum);
        const yearStart = new Date(Date.UTC(newDate.getUTCFullYear(), 0, 1));

        return `${Math.ceil(
            ((newDate.getTime() - yearStart.getTime()) / 86400000 + 1) / 7
        )}`;
    }

    buildPaxLabel(paxesFormat) {
        var totalRooms = 0;
        var urlPax = [];
        for (const param of paxesFormat) {
            totalRooms += 1;
            let paxSplit = param.split('|');
            let adults = paxSplit[0] ? Number(paxSplit[0]) : 0;
            let kidsSlit = paxSplit[1] ? paxSplit[1].split(',') : [];
            let kids = kidsSlit.map(kid => { return { year: Number(kid) } })
            urlPax.push(`room${totalRooms}.adults:${adults}|room${totalRooms}.kids:${kidsSlit}`);
    
        }
        return urlPax.join(',');
    }
    

    isRAPD() {
        return !this._roomRates.rooms ? false : this._roomRates.rooms.map((item) => {
            return item.rate.some(rate => rate.IsBookNowPayLaterApplicable);
        }).some(isTrue => isTrue);
    }
    getavailableGetRooms() {
        var DetailNoAvailable = "";
        this.roomsTax.map((item) => {
            var roomFind = this.roomsAval.find(x => x.roomId == item.roomId);
            if (roomFind) {
                if (item.unavailableStatus.availabilityStatus.includes("RoomCapacity")) {
                    DetailNoAvailable = "capacity"
                } else if (item.unavailableStatus.availabilityStatus.includes("MinimumStay")) {
                    DetailNoAvailable = "stay"
                }
            }
        });
        return DetailNoAvailable;
    }
    /*availabilityValue*/
    getMaxMinStay(minmax) {
        /*true: max, false : min*/
        var MaxStay = 0;
        var minStay = 0;
        this.roomsTax.map((item) => {
            var roomFind = this.roomsAval.find(x => x.roomId == item.roomId);
            if (roomFind) {
                if (item.unavailableStatus.availabilityStatus.includes("MinimumStay")) {
                    var maxvalue = parseInt(item.unavailableStatus.availabilityValue);
                    if (minStay < maxvalue) {
                        minStay = maxvalue;
                    }
                }
            }
        });
        return minmax ? MaxStay : minStay;
    }
    getMaxMinCapacity(minmax) {
        /*true: max, false : min*/
        var MaxCapacity = 0;
        var MinCapacity = 0;
        this.roomsTax.map((item) => {
            var roomFind = this.roomsAval.find(x => x.roomId == item.roomId);
            if (roomFind) {
                if (item.unavailableStatus.availabilityStatus.includes("RoomCapacity")) {
                    if (MaxCapacity < Math.max(...item.capacityList) + 1) {
                        MaxCapacity = Math.max(...item.capacityList) + 1;
                    }
                    if (MinCapacity < Math.min(...item.capacityList) + 1) {
                        MinCapacity = Math.min(...item.capacityList) + 1;
                    }
                }
            }    
        });
        return minmax ? MaxCapacity : MinCapacity;
    }

    isValidCoordinate(location) {
        const { latitude, longitude } = location;
        if (latitude === null || latitude === undefined || latitude === '' ||
            longitude === null || longitude === undefined || longitude === '') {
            return false;
        }
    
        const latNum = parseFloat(latitude);
        const lngNum = parseFloat(longitude);
    
        if (isNaN(latNum) || isNaN(lngNum)) {
            return false;
        }

        return true;
    }

}